var map = {
	"./project_dev_ascen-portal.js": [
		4950,
		950
	],
	"./project_dev_hoxtonmix-portal.js": [
		6621,
		621
	],
	"./project_prod_ascen-portal.js": [
		90652,
		652
	],
	"./project_prod_hoxtonmix-portal.js": [
		64540,
		540
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 99813;
module.exports = webpackAsyncContext;